module.exports = __webpack_public_path__ + "static/media/facebook_color_big.e14feb27.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/facebook_color_big.png
// module id = ./src/assets/media/facebook_color_big.png
// module chunks = 16